//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionLoginApiSuccess, ActionPlatformSecuritySuccess, ActionSetIsLoggedIn, ActionBlurApp } from './actions';
import { PlatformSecurity, SessionData, SessionUser } from 'features/Security/state/types';

export interface SecurityState {
    isLoggedIn: boolean,
    accessToken?: string,
    user?:SessionUser,
    platformSecurity?: PlatformSecurity,
    blurAPP?: boolean
}

const defaultState: SecurityState = {
    isLoggedIn: false

};

type SecurityAction = ActionLoginApiSuccess | ActionSetIsLoggedIn | ActionBlurApp | ActionPlatformSecuritySuccess;

function securityReducer(state: SecurityState = defaultState, action: SecurityAction): SecurityState {

    switch (action.type) {
        case ACTIONS.POST_USERDATA_API_SUCCESS:
        case ACTIONS.POST_LOGIN_API_SUCCESS:
            {
                const { accessToken, user } = action as ActionLoginApiSuccess;
                return {
                    ...state,
                    accessToken,
                    user
                }
            }
        case ACTIONS.SECURITY_IS_LOGGED_IN:
            {
                const { isLoggedIn, user } = action as ActionSetIsLoggedIn
                return {
                    ...state,
                    isLoggedIn: true,
                    user
                }
            }
        case ACTIONS.GET_PLATFORM_SECURITY_API_SUCCESS:
                {
                    const { platformSecurity } = action as ActionPlatformSecuritySuccess;
                    return {
                        ...state,
                        platformSecurity
                    }
                }
        case ACTIONS.BLUR_APP:
            {
                const { blurAPP } = action as ActionBlurApp
                return {
                    ...state,
                    blurAPP: blurAPP
                }
            }
    }
    return {
        ...state
    }
}

export default securityReducer;